import React, { useContext, useEffect, useState, useRef } from "react";
import { useTranslation, withTranslation } from "react-i18next";
import "./StatusHeader.scss";
import LinearProgress from "@mui/material/LinearProgress";
import pendingImage from "../../assets/images/openOrderGif1.gif";
import processImage from "../../assets/images/openOrderGif2.gif";

// import pendingImage from "../../assets/images/BookOpen.svg";
// import processImage from "../../assets/images/BookOpen.svg";
import { Button, IconButton } from "@material-ui/core";
import { useSelector, useDispatch } from "react-redux";
import Avatar from "@mui/material/Avatar";
import Fade from "react-reveal/Fade";

const StatusHeader = ({ url, scroll }) => {
  const { t } = useTranslation();
  const appState = useSelector((state) => state);
  const appDispatch = useDispatch();
  const [progress, setProgress] = useState(70);

  const handleClickOpenQrCode = () => {
    appDispatch({
      type: "setShareInvoiceQrcode",
      shareInvoiceQrcode: true,
    });
  };

  useEffect(() => {
    const timer = setInterval(() => {
      setProgress((oldProgress) => {
        if (oldProgress === 80) {
          return 20;
        }
        const diff = Math.random() * 10;
        return Math.min(oldProgress + diff, 80);
      });
    }, 500);

    return () => {
      clearInterval(timer);
    };
  }, []);

  return (
    <div
      id="status-header"
      className={`  col-md-12 col-xl-6 offset-xl-3 mr-auto  header ${
        scroll > 0 ? `classeOnScrollOpenOrder` : `classeOffScrollOpenOrder`
      } `}
    >
      <div className={`d-flex justify-content-between ${scroll ? "" : ""}`}>
        <div className="d-flex align-items-center">
            {" "}
            <Avatar
              variant="square"
              src={processImage}
              className="statusAvatar"
            ></Avatar>
          <div className="mx-2">
            <p className="status-heading mb-1">
              {t("open-order.Order-is-Serving")}{" "}
            </p>
            <p className="status-description mb-0 text-muted text-capitalize">
              {t("open-order.Order-is-Preparing")}
            </p>
          </div>
        </div>
        <div>
          {appState.serviceMode.includes("share-bill") && (
            <IconButton
              id="headerBtn"
              className="qrCodeIconButton"
              onClick={() =>
                appDispatch({
                  type: "setShareBillPopup",
                  shareBillPopup: true,
                  shareBillUrl: url,
                })
              }
            >
              <svg
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M2 8C1.45 8 0.979 7.804 0.587 7.412C0.195667 7.02067 0 6.55 0 6V2C0 1.45 0.195667 0.979 0.587 0.587C0.979 0.195667 1.45 0 2 0H6C6.55 0 7.021 0.195667 7.413 0.587C7.80433 0.979 8 1.45 8 2V6C8 6.55 7.80433 7.02067 7.413 7.412C7.021 7.804 6.55 8 6 8H2ZM2 6H6V2H2V6ZM2 18C1.45 18 0.979 17.8043 0.587 17.413C0.195667 17.021 0 16.55 0 16V12C0 11.45 0.195667 10.979 0.587 10.587C0.979 10.1957 1.45 10 2 10H6C6.55 10 7.021 10.1957 7.413 10.587C7.80433 10.979 8 11.45 8 12V16C8 16.55 7.80433 17.021 7.413 17.413C7.021 17.8043 6.55 18 6 18H2ZM2 16H6V12H2V16ZM12 8C11.45 8 10.9793 7.804 10.588 7.412C10.196 7.02067 10 6.55 10 6V2C10 1.45 10.196 0.979 10.588 0.587C10.9793 0.195667 11.45 0 12 0H16C16.55 0 17.021 0.195667 17.413 0.587C17.8043 0.979 18 1.45 18 2V6C18 6.55 17.8043 7.02067 17.413 7.412C17.021 7.804 16.55 8 16 8H12ZM12 6H16V2H12V6ZM16.5 18C16.3667 18 16.25 17.95 16.15 17.85C16.05 17.75 16 17.6333 16 17.5V16.5C16 16.3667 16.05 16.25 16.15 16.15C16.25 16.05 16.3667 16 16.5 16H17.5C17.6333 16 17.75 16.05 17.85 16.15C17.95 16.25 18 16.3667 18 16.5V17.5C18 17.6333 17.95 17.75 17.85 17.85C17.75 17.95 17.6333 18 17.5 18H16.5ZM10.5 12C10.3667 12 10.25 11.95 10.15 11.85C10.05 11.75 10 11.6333 10 11.5V10.5C10 10.3667 10.05 10.25 10.15 10.15C10.25 10.05 10.3667 10 10.5 10H11.5C11.6333 10 11.75 10.05 11.85 10.15C11.95 10.25 12 10.3667 12 10.5V11.5C12 11.6333 11.95 11.75 11.85 11.85C11.75 11.95 11.6333 12 11.5 12H10.5ZM12.5 14C12.3667 14 12.25 13.95 12.15 13.85C12.05 13.75 12 13.6333 12 13.5V12.5C12 12.3667 12.05 12.25 12.15 12.15C12.25 12.05 12.3667 12 12.5 12H13.5C13.6333 12 13.75 12.05 13.85 12.15C13.95 12.25 14 12.3667 14 12.5V13.5C14 13.6333 13.95 13.75 13.85 13.85C13.75 13.95 13.6333 14 13.5 14H12.5ZM10.5 16C10.3667 16 10.25 15.95 10.15 15.85C10.05 15.75 10 15.6333 10 15.5V14.5C10 14.3667 10.05 14.25 10.15 14.15C10.25 14.05 10.3667 14 10.5 14H11.5C11.6333 14 11.75 14.05 11.85 14.15C11.95 14.25 12 14.3667 12 14.5V15.5C12 15.6333 11.95 15.75 11.85 15.85C11.75 15.95 11.6333 16 11.5 16H10.5ZM12.5 18C12.3667 18 12.25 17.95 12.15 17.85C12.05 17.75 12 17.6333 12 17.5V16.5C12 16.3667 12.05 16.25 12.15 16.15C12.25 16.05 12.3667 16 12.5 16H13.5C13.6333 16 13.75 16.05 13.85 16.15C13.95 16.25 14 16.3667 14 16.5V17.5C14 17.6333 13.95 17.75 13.85 17.85C13.75 17.95 13.6333 18 13.5 18H12.5ZM14.5 16C14.3667 16 14.25 15.95 14.15 15.85C14.05 15.75 14 15.6333 14 15.5V14.5C14 14.3667 14.05 14.25 14.15 14.15C14.25 14.05 14.3667 14 14.5 14H15.5C15.6333 14 15.75 14.05 15.85 14.15C15.95 14.25 16 14.3667 16 14.5V15.5C16 15.6333 15.95 15.75 15.85 15.85C15.75 15.95 15.6333 16 15.5 16H14.5ZM14.5 12C14.3667 12 14.25 11.95 14.15 11.85C14.05 11.75 14 11.6333 14 11.5V10.5C14 10.3667 14.05 10.25 14.15 10.15C14.25 10.05 14.3667 10 14.5 10H15.5C15.6333 10 15.75 10.05 15.85 10.15C15.95 10.25 16 10.3667 16 10.5V11.5C16 11.6333 15.95 11.75 15.85 11.85C15.75 11.95 15.6333 12 15.5 12H14.5ZM16.5 14C16.3667 14 16.25 13.95 16.15 13.85C16.05 13.75 16 13.6333 16 13.5V12.5C16 12.3667 16.05 12.25 16.15 12.15C16.25 12.05 16.3667 12 16.5 12H17.5C17.6333 12 17.75 12.05 17.85 12.15C17.95 12.25 18 12.3667 18 12.5V13.5C18 13.6333 17.95 13.75 17.85 13.85C17.75 13.95 17.6333 14 17.5 14H16.5Z"
                  fill="#1A1A1A"
                />
              </svg>
            </IconButton>
          )}
        </div>
      </div>

      <div className="direction-ltr">
        <div className="w-100 pb-3 px-3 progress_Status_Header">
          <div className="row">
            <div className="col-3 px-0">
              <LinearProgress
                className="w-100 mt-3"
                variant="determinate"
                value={`100`}
              />
            </div>
            <div className="col-6 ">
              <LinearProgress
                className="w-100 mt-3"
                variant="determinate"
                value={`${progress}`}
              />
            </div>
            <div className="col-3 px-0">
              <LinearProgress
                className="w-100 mt-3"
                variant="determinate"
                value={`0`}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withTranslation()(StatusHeader);
